/**
 * What is waiting for this user's decision.
 *
 * Three such queues already existed separately — mail drafts, contact-form
 * submissions, flagged addresses — and none of them was counted anywhere.
 * That was survivable while a person made each of those things while sitting
 * there; standing orders break it, because work now arrives overnight.
 *
 * `getApprovalCount` is its own call because the sidebar badge is fetched on
 * every navigation and has no use for the rows — the same reason
 * `/email-campaigns/reply-summary` exists beside the inbox.
 */

import apiClient from './api'

export interface ApprovalCount {
  total: number
  /** How much of the total arrived without anyone asking. */
  from_standing_orders: number
}

export interface ApprovalItem {
  kind: string
  id: string
  title: string
  detail?: string | null
  standing_order_id?: string | null
  created_at?: string | null
}

export interface ApprovalGroup {
  kind: string
  label: string
  count: number
  /** Where to go about them — a path the browser already knows. */
  screen: string
  items: ApprovalItem[]
}

export interface Approvals {
  total: number
  from_standing_orders: number
  groups: ApprovalGroup[]
}

export const getApprovalCount = async (): Promise<ApprovalCount> => {
  const res = await apiClient.get('/approvals/count')
  return { total: res.data?.total ?? 0, from_standing_orders: res.data?.from_standing_orders ?? 0 }
}

export const getApprovals = async (): Promise<Approvals> => {
  const res = await apiClient.get('/approvals')
  return {
    total: res.data?.total ?? 0,
    from_standing_orders: res.data?.from_standing_orders ?? 0,
    groups: res.data?.groups ?? [],
  }
}
